/** Decorative icon: coloured lotto balls tumbling inside a sphere. */
export function LottoBallsBounceIcon() {
  return (
    <svg
      className="lotto-balls-bounce"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      aria-hidden="true"
      focusable="false"
    >
      {/* Sphere outline */}
      <circle className="lotto-balls-bounce__sphere" cx="11" cy="11" r="10.2" />
      {/* Balls — all centered at (11,11); CSS translate animates them around */}
      <circle className="lotto-balls-bounce__ball lotto-balls-bounce__ball--1" cx="11" cy="11" r="2.2" />
      <circle className="lotto-balls-bounce__ball lotto-balls-bounce__ball--2" cx="11" cy="11" r="2.2" />
      <circle className="lotto-balls-bounce__ball lotto-balls-bounce__ball--3" cx="11" cy="11" r="2.2" />
      <circle className="lotto-balls-bounce__ball lotto-balls-bounce__ball--4" cx="11" cy="11" r="2.2" />
      <circle className="lotto-balls-bounce__ball lotto-balls-bounce__ball--5" cx="11" cy="11" r="2.2" />
      {/* Gloss highlight */}
      <ellipse className="lotto-balls-bounce__gloss" cx="8.5" cy="7" rx="2.8" ry="1.7" />
    </svg>
  );
}
